import { PageHeader } from "@plataforma/design-system";
import { useAppConfig } from "../../app/config";
import { HelpButton } from "../../app/help";
import { FiscalSection } from "./FiscalSection";
import { LocationsSection } from "./LocationsSection";
import "./settings.css";

export function SettingsPage() {
  const { has } = useAppConfig();
  return (
    <>
      <PageHeader title="Configurações" actions={<HelpButton topic="settings" />} />
      <div className="settings-grid">
        {has("agenda") ? <LocationsSection /> : null}
        {has("invoices") ? <FiscalSection /> : null}
      </div>
    </>
  );
}
